import React from "react";
import { useTranslation } from "react-i18next";
import { useRetrieveCostProfiles } from "@planzone/view-models";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { CostProfiles } from "./costProfiles";
import { SelectedProfile } from "./selectedProfile";
import styles from "./styles.scss";

function AssignCostProfileToResource({ resource }: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    costProfiles,
    retrieveCostProfiles,
  } = useRetrieveCostProfiles();

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveCostProfiles();
  }, []);

  return (
    <SelectList listClassName={styles.list}>
      {({ isOpen, select }) => ({
        input: !!resource.costProfile ? (
          <SelectedProfile costProfile={resource.costProfile} />
        ) : (
          <div className={styles.assignCostProfileToResource}>
            <p>+ {t("editResource.addCostProfile")}</p>
          </div>
        ),
        list: (
          <CostProfiles
            costProfiles={costProfiles}
            resource={resource}
            select={() => select(false)}
          />
        ),
      })}
    </SelectList>
  );
}

export { AssignCostProfileToResource };
